"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Chat = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _styles = require("./styles");

var _react = require("react");

var _ButtonV = require("../../atoms/ButtonV2");

var _ContentChat = require("./ContentChat");

var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");

var _material = require("@mui/material");

var _utils = require("../../../global-files/utils");

var _jsxRuntime = require("react/jsx-runtime");

var Chat = function Chat(props) {
  var chatType = props.chatType,
      chatContainerType = props.chatContainerType,
      _props$chatData = props.chatData,
      chatData = _props$chatData === void 0 ? {} : _props$chatData,
      classNameContainerFixed = props.classNameContainerFixed,
      _props$size = props.size,
      size = _props$size === void 0 ? 14 : _props$size;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      showPopUpChat = _useState2[0],
      setShowPopUpChat = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      data = _useState4[0],
      setData = _useState4[1];

  var _ref = chatData || {},
      ticketCompany = _ref.ticketCompany,
      retailerId = _ref.retailerId;

  (0, _react.useEffect)(function () {
    switch (chatType) {
      case "merchant_product":
        validateChatMerchantProduct();
        break;

      case "order_product":
        validateChatOrderProduct();
        break;

      case "ticket":
        validateChatTicket();
        break;

      case "product_status":
        validateProductStatus();
        break;

      default:
        setData({
          code: 404,
          message: "El tipo de chat especificado \"".concat(chatType, "\" no es valido"),
          errorDetail: ""
        });
    }
  }, [chatType]);

  var validateProductStatus = function validateProductStatus() {
    var userToken = chatData.userToken,
        id = chatData.id,
        version = chatData.version,
        retailerId = chatData.retailerId,
        status = chatData.status,
        orderId = chatData.orderId;
    if (!isValidGeneral(userToken, id)) return; // validar el ID de la cadena asociada al producto en la OT

    if (!(0, _utils.isValidNaturalNumber)(retailerId)) {
      setDataError("La cadena relacionada al producto no es válida");
      return;
    } // validar el ID de la version asociada al producto en la OT


    if (!(0, _utils.isValidNaturalNumber)(version)) {
      setDataError("La versión del producto no es válida");
      return;
    }

    if (orderId && !(0, _utils.isValidNaturalNumber)(orderId)) {
      setDataError("La orden del producto no es válida");
      return;
    }

    setData({
      userToken: userToken,
      id: id,
      version: version,
      retailerId: retailerId,
      orderId: orderId,
      status: status
    });
  };

  var isValidGeneral = function isValidGeneral(userToken, id) {
    // validar token del user
    if ((0, _utils.isStringEmpty)(userToken)) {
      setDataError("El token del usuario no es valido");
      return false;
    } // validar ID del producto


    if (!(0, _utils.isValidNaturalNumber)(id)) {
      setDataError("El ID del producto no es valido");
      return false;
    }

    return true;
  }; // validar props que se requieren para el tipo de chat "order_product"


  var validateChatOrderProduct = function validateChatOrderProduct() {
    var userToken = chatData.userToken,
        id = chatData.id,
        orderId = chatData.orderId,
        retailerId = chatData.retailerId;
    if (!isValidGeneral(userToken, id)) return; // validar el ID de la OT en donde se encuentra el producto

    if (!(0, _utils.isValidNaturalNumber)(orderId)) {
      setDataError("El ID de la orden del producto no es valido");
      return;
    } // validar el ID de la cadena asociada al producto en la OT


    if (!(0, _utils.isValidNaturalNumber)(retailerId)) {
      setDataError("La cadena relacionada al producto no es valida");
      return;
    }

    setData({
      userToken: userToken,
      id: id,
      orderId: orderId,
      retailerId: retailerId
    });
  }; // validar props que se requieren para el tipo de chat "merchants_product"


  var validateChatMerchantProduct = function validateChatMerchantProduct() {
    var userToken = chatData.userToken,
        id = chatData.id,
        version = chatData.version;
    if (!isValidGeneral(userToken, id)) return; // validar la version del producto

    if (!(0, _utils.isValidNaturalNumber)(version)) {
      setDataError("La version del producto no es valida");
      return;
    }

    setData({
      userToken: userToken,
      id: id,
      version: version
    });
  }; // validar props que se requieren para el tipo de chat "ticket"


  var validateChatTicket = function validateChatTicket() {
    var currentUser = chatData.currentUser,
        id = chatData.id,
        statusTicket = chatData.statusTicket,
        ticketOwnerUserId = chatData.ticketOwnerUserId; // validar el token del usuario conectado

    if ((0, _utils.isStringEmpty)(currentUser === null || currentUser === void 0 ? void 0 : currentUser.token)) {
      setDataError("Tu identificación de usuario no fue especificado");
      return;
    } // validar si ID del usuario conectado


    if (!(0, _utils.isValidNaturalNumber)(currentUser === null || currentUser === void 0 ? void 0 : currentUser.id)) {
      setDataError("Tu ID de usuario no fue especificado");
      return;
    } // validar si ID de la compañia del usuario conectado


    if (!(0, _utils.isValidNaturalNumber)(currentUser === null || currentUser === void 0 ? void 0 : currentUser.companyId)) {
      setDataError("El ID de tu compañia no fue especificado");
      return;
    } // validar si el usuario conectado es de tecnologia o no


    if (![false, true].includes(currentUser === null || currentUser === void 0 ? void 0 : currentUser.isUserTech)) {
      setDataError("Tu tipo de usuario no fue especificado");
      return;
    } // validar ID del ticket


    if (!(0, _utils.isValidNaturalNumber)(id)) {
      setDataError("El ID del ticket no es valido");
      return;
    } // validar ID del usuario que creó el ticket


    if (!(0, _utils.isValidNaturalNumber)(ticketOwnerUserId)) {
      setDataError("El ID del usuario al que le pertenece el ticket no es valido");
      return;
    } // validar el status del chat


    if (!["IN_PROGRESS", "PENDING", "COMPLETED"].includes(statusTicket)) {
      setDataError("El estatus del ticket no es valido");
      return;
    }

    var statusChat = "open";
    if (statusTicket === "COMPLETED") statusChat = "closed"; // convertir user TECH a NORMAL si es el propietario del ticket

    var isUserTech = currentUser.isUserTech;

    if (isUserTech && currentUser.id === ticketOwnerUserId) {
      isUserTech = false;
    }

    setData({
      currentUser: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, currentUser), {}, {
        isUserTech: isUserTech
      }),
      id: id,
      statusChat: statusChat
    });
  };

  var setDataError = function setDataError(errorDetail) {
    setData({
      code: 404,
      message: "No se especificaron algunos datos requeridos para el tipo de chat \"".concat(chatType, "\""),
      errorDetail: errorDetail
    });
  };

  if ((chatContainerType === null || chatContainerType === void 0 ? void 0 : chatContainerType.toLowerCase()) === "fixed") {
    /* chat tipo fixed */
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ContainerFixed, {
      className: classNameContainerFixed,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ContentChat.ContentChat, {
        chatType: chatType === null || chatType === void 0 ? void 0 : chatType.toLowerCase(),
        chatContainerType: "fixed",
        dataChat: data,
        showBtnClose: false,
        ticketCompany: ticketCompany,
        activeRetailer: props.activeRetailer || {
          id: retailerId
        }
      })
    });
  } else {
    /* chat tipo popUp */
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ContainerBtnPopUpChat, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ButtonV.ButtonV2, {
          className: "container-btn-popUpChat",
          type: "whiteS2",
          size: size,
          borderType: "circle",
          icon: _freeSolidSvgIcons.faComments,
          onClick: function onClick() {
            setShowPopUpChat(!showPopUpChat);
          }
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Slide, {
        direction: "left",
        in: showPopUpChat,
        timeout: 400,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ContainerPopUp, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ContentChat.ContentChat, {
            chatType: chatType === null || chatType === void 0 ? void 0 : chatType.toLowerCase(),
            chatContainerType: "popUp",
            dataChat: data,
            showPopUpChat: showPopUpChat,
            showBtnClose: true,
            ticketCompany: ticketCompany,
            onClickBtnClose: function onClickBtnClose() {
              setShowPopUpChat(false);
            },
            activeRetailer: props.activeRetailer || {
              id: retailerId
            }
          })
        })
      })]
    });
  }
};

exports.Chat = Chat;